import React, { useRef, useState } from "react";
import {
    Home,
    Box,
    ShoppingCart,
    UserPlus,
    Users,
    FileText,
    ReceiptIndianRupee,
    Wallet,
    School,
    Layers,
    Menu as MenuIcon,
    MessageSquare,
    Wallet2,
    Image,
    Workflow,
    ChevronRight,
    ChevronDown,
    ChevronsUpDown,
    Settings,
    CreditCard,
    LogOut,
    Menu,
    SidebarClose,
    X,
    HelpCircle,
    LayoutDashboard,
    History,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getDecryptedUserFromCookie } from './utils/getCookie';
import usermain from "../Img/user.png"

const menuData = [
    // { title: "Dashboard", icon: Home, path: "/", type: "link" },
    {
        title: "Inventory",
        icon: Box,
        type: "accordion",
        submenus: [
            { title: "Product / Services", path: "/products", type: "link" },
            { title: "Grouped Products", path: "/grouped-product", type: "link" },
            // { title: "Units", path: "/unit", visibleFor: "Admin", type: "link" },
            { title: "Pincode", path: "/pincode", visibleFor: "Admin", type: "link" },
            { title: "Delivery", path: "/delivery", visibleFor: "Admin", type: "link" },
            { title: "Variations", path: "/features", visibleFor: "Admin", type: "link" },
            { title: "Categories", path: "/category", visibleFor: "Admin", type: "link" },
            { title: "Coupon", path: "/coupon", visibleFor: "Admin", type: "link" },

        ],
    },
    { title: "Orders", icon: ShoppingCart, path: "/orders", type: "link", badge: "100" },
    // // { title: "CRM", icon: UserPlus, path: "/crm", type: "link" },
    // { title: "Customer", icon: Users, path: "/customer", type: "link" },
    // { title: "Invoice", icon: FileText, path: "/invoice", type: "link" },
    // { title: "Receipt", icon: ReceiptIndianRupee, path: "/receipt", type: "link" },
    // { title: "Expense", icon: Wallet, path: "/expense", type: "link" },
    { title: "Blog", icon: Wallet, path: "/blog", type: "link" },
    // // { title: "Admission", icon: School, path: "/admission", type: "link", visibleFor: "Admin", visibleSk: "Skates" },
    // { title: "Admission", icon: School, path: "/admission", type: "link", visibleFor: "Admin", visibleSk: "Skates"  },
    // { title: "Category", icon: Layers, path: "/category-main", type: "link", visibleFor: "SuperAdmin" },
    {
        title: "Website / App",
        icon: Box,
        type: "accordion",
        submenus: [
            { title: "Users", path: "/user-records", visibleFor: "Admin", type: "link" },
            { title: "Slider", path: "/slider", visibleFor: "Admin", type: "link" },
            { title: "Track Slider", path: "/track-slider", visibleFor: "Admin", type: "link" },
            { title: "Hero Section", path: "/herosection", visibleFor: "Admin", type: "link" },
            { title: "Home Sections", path: "/newarrival", visibleFor: "Admin", type: "link" },
            { title: "Call To Action1", path: "/calltoactionfirst", visibleFor: "Admin", type: "link" },
            { title: "Call To Action2", path: "/calltoactionsecond", visibleFor: "Admin", type: "link" },
            { title: "Review", path: "/review", visibleFor: "Admin", type: "link" },
            { title: "Offers", path: "/offer", visibleFor: "Admin", type: "link" },

        ],
    },
    {
        title: "Customization",
        icon: Box,
        type: "accordion",
        submenus: [
            { title: "Headline", path: "/headline", visibleFor: "Admin", type: "link" },
            { title: "Footer", path: "/footer-setting", visibleFor: "Admin", type: "link" },
            { title: "Request Callback", path: "/calltoaction-form", visibleFor: "Admin", type: "link" },
            { title: "Footer Setting", path: "/footer-setting", visibleFor: "Admin", type: "link" },

        ],
    },
    {
        title: "Blogs",
        icon: Box,
        type: "accordion",
        submenus: [
            { title: "Blogs", path: "/blog", visibleFor: "Admin", type: "link" },
            // { title: "Add Blog", path: "/add-blog", visibleFor: "Admin", type: "link" },
            { title: "Authors", path: "/author", visibleFor: "Admin", type: "link" },
            { title: "Comments", path: "/comment", visibleFor: "Admin", type: "link" },
            { title: "Category", path: "/blog-category", visibleFor: "Admin", type: "link" },

        ],
    },
    {
        title: "Catlog",
        icon: Box,
        type: "accordion",
        submenus: [
            { title: "Catlog Category", path: "/catlog-catgeory", visibleFor: "Admin", type: "link" },
            { title: "Catlog", path: "/catlog", visibleFor: "Admin", type: "link" },

        ],
    },
    { title: "Menus", icon: MenuIcon, path: "/menus", type: "link", visibleFor: "Admin" },
    // {
    //     title: "Referral",
    //     icon: Users,
    //     type: "accordion",
    //     submenus: [
    //         { title: "Create refer", path: "/refer", type: "link" },
    //         { title: "Referral Usage", path: "/refer-usage", type: "link" },
    //     ],
    //     visibleFor: "Admin",
    // },
    { title: "Wallet", icon: Wallet2, path: "/wallet-target", type: "link", visibleFor: "Admin" },
    { title: "Testimonial", icon: MessageSquare, path: "/testimonial", type: "link", visibleFor: "Admin" },
    { title: "Brand", icon: Box, path: "/brand", type: "link", visibleFor: "Admin" },
    // { title: "Plan", icon: Layers, path: "/plan", type: "link", visibleFor: "SuperAdmin" },
    // { title: "Media Library", icon: Image, path: "/media", type: "link", visibleFor: "Admin" },
    {
        title: "Users",
        icon: Users,
        type: "accordion",
        submenus: [{ title: "All Records", path: "/alluser-records", type: "link" }],
        visibleFor: "SuperAdmin",
    },
    // {
    //     title: "Teams",
    //     icon: Users,
    //     type: "accordion",
    //     submenus: [
    //         { title: "Department", path: "/department", type: "link" },
    //         { title: "Team Directory", path: "/team-directory", type: "link" },
    //         { title: "Team Attendance", path: "/team-attendance", type: "link" },
    //     ],
    // },
    // { title: "Google Ads", icon: Workflow, path: "/integrations", type: "link" },
];

const Sidebar = ({
    collapsed,
    setCollapsed,
    mobileOpen,
    setMobileOpen,
    isMobile,
    onCloseMobile,
    totalnewOrder
}) => {
    const [openAccordions, setOpenAccordions] = useState({});
    const [tooltip, setTooltip] = useState(null);
    const dropdownRef = useRef(null);
    const sidebarRef = useRef(null);
    const user = getDecryptedUserFromCookie();
    const navigate = useNavigate();
    console.log(user)
    console.log(user)

    const toggleAccordion = (id) => {
        setOpenAccordions((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const showTooltip = (e, title) => {
        if (!collapsed || isMobile) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            title,
            top: rect.top + rect.height / 2,
        });
    };

    const hideTooltip = () => setTooltip(null);

    const dynamicMenuData = menuData.map(item => {
        if (item.title === "Orders") {
            return {
                ...item,
                badge: totalnewOrder > 0 ? String(totalnewOrder) : undefined
            };
        }
        return item;
    });

    const handlelogout = async () => {
        try {
            localStorage.removeItem("2xgxgshdugyywerw12eccom");
            localStorage.removeItem("2xgxgshdugyywerw12gh");
            navigate("/login");
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    const filteredNavItems = dynamicMenuData
        .filter(item => {
            if (item.hidden) return false;

            // If no visibility restriction, allow by default
            const userTypeMatches = !item.visibleFor || item.visibleFor === user?.type;
            const visibleSkMatches = !item.visibleSk || item.visibleSk === user?.category;

            return userTypeMatches && visibleSkMatches;
        })
        .map(item => {
            if (item.submenus) {
                const filteredSubNav = item.submenus.filter(sub => {
                    return !sub.visibleFor || sub.visibleFor === user?.type;
                });
                return { ...item, submenus: filteredSubNav };
            }
            return item;
        })

        .filter(item => {
            // If item had subNav and all were filtered out, remove it
            return !item.submenus || item.submenus.length > 0;
        })



    const renderMenuItem = (item, parentId = "", depth = 0) => {
        const itemId = `${parentId}-${item.title}`;
        const isOpen = openAccordions[itemId];
        const Icon = item.icon;

        const button = (
            <button
                type="button"
                onClick={() => {
                    if (item.type === "link") {
                        navigate(item.path);
                        if (isMobile) onCloseMobile();
                    } else {
                        toggleAccordion(itemId);
                    }
                }}
                onMouseEnter={(e) => showTooltip(e, item.title)}
                onMouseLeave={hideTooltip}
                className={`
          group relative flex w-full items-center gap-x-3 py-2 px-2.5
          text-sm text-gray-800 rounded-lg hover:bg-gray-100
          focus:outline-none focus:bg-gray-100
          ${collapsed ? "justify-center" : ""}
        `}
            >
                {Icon && <Icon className="size-4 flex-shrink-0" />}
                {!collapsed && (
                    <>
                        <span className="flex-1 text-left">{item.title}</span>
                        {item.badge && (
                            <span className="ms-auto py-0.5 px-1.5 inline-flex items-center gap-x-1.5 text-xs bg-red-100 text-red-800 rounded-full font-medium">
                                {item.badge}
                            </span>
                        )}
                        {item.type === "accordion" && (
                            <span className="ms-auto">
                                {isOpen ? (
                                    <ChevronDown className="size-4 text-gray-600" />
                                ) : (
                                    <ChevronRight className="size-4 text-gray-600" />
                                )}
                            </span>
                        )}
                    </>
                )}
            </button>
        );

        if (item.type === "link") {
            return <li key={item.title}>{button}</li>;
        }

        return (
            <li key={item.title}>
                {button}
                <div
                    className={`
            overflow-hidden transition-all duration-300
            ${isOpen && !collapsed ? "max-h-96" : "max-h-0"}
          `}
                >
                    <ul className={`pt-1 space-y-1 ${depth === 0 ? "ps-7" : "ps-2"}`}>
                        {item.submenus &&
                            item.submenus.map((sub) => renderMenuItem(sub, itemId, depth + 1))}
                    </ul>
                </div>
            </li>
        );
    };

    const sidebarWidth = isMobile
        ? mobileOpen
            ? "w-60"
            : "w-0"
        : collapsed
            ? "w-16"
            : "w-60";

    return (
        <>
            <div
                ref={sidebarRef}
                className={`
          fixed top-0 start-0 bottom-0 z-50 bg-white border-e border-gray-200
          transition-all duration-300 ease-in-out flex flex-col overflow-hidden
          ${sidebarWidth} h-full
        `}
            >
                <header
                    className={`flex items-center justify-between border-b border-gray-200 py-2 transition-all duration-300
            ${collapsed && !isMobile ? "flex-col gap-2 px-4" : "flex-row pl-4"}`}
                >
                    <div></div>
                    <div
                        onClick={() => {
                            navigate("/");
                            if (isMobile) onCloseMobile();
                        }}
                        className={`cursor-pointer flex items-center justify-center overflow-hidden transition-all duration-300
              ${collapsed && !isMobile ? "w-12" : "w-20"}`}
                    >
                        <img
                            src="/assets/oms-logo-blue.png"
                            alt="logo"
                            className="h-full object-contain transition-all duration-300"
                        />
                    </div>

                    {!isMobile && (
                        <button
                            onClick={() => setCollapsed(!collapsed)}
                            className="w-10 rounded-full flex justify-center items-center cursor-pointer transition-all hover:bg-gray-100"
                        >
                            {collapsed ? (
                                <MenuIcon size={20} className="text-gray-700" />
                            ) : (
                                <SidebarClose size={20} className="text-gray-700" />
                            )}
                        </button>
                    )}

                    {isMobile && (
                        <button
                            onClick={onCloseMobile}
                            className="w-10 rounded-full flex justify-center items-center cursor-pointer transition-all hover:bg-gray-100"
                        >
                            <X size={20} className="text-gray-700" />
                        </button>
                    )}
                </header>

                <nav className="flex-1 overflow-y-auto p-2 pb-20 
  [&::-webkit-scrollbar]:w-1 
  [&::-webkit-scrollbar-thumb]:rounded-full 
  [&::-webkit-scrollbar-track]:bg-transparent 
  [&::-webkit-scrollbar-thumb]:bg-blue-500">
                    <ul className="space-y-1">{filteredNavItems.map(i => renderMenuItem(i))}</ul>
                </nav>


                <footer className="border-t border-gray-200 p-1">
                    <UserDropdown collapsed={collapsed} navigate={navigate} dropdownRef={dropdownRef} user={user} handlelogout={handlelogout} />
                </footer>
            </div>

            {/* Tooltip */}
            {tooltip && collapsed && !isMobile && (
                <div
                    className="fixed z-50 bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap pointer-events-none shadow-lg"
                    style={{
                        left: sidebarRef.current?.getBoundingClientRect().right + 8,
                        top: tooltip.top,
                        transform: "translateY(-50%)",
                    }}
                >
                    {tooltip.title}
                </div>
            )}

            {isMobile && !mobileOpen && (
                <div className="flex justify-between gap-2 items-center relative w-full z-50 p-2 bg-transparent mb-2">
                    <button
                        onClick={() => setMobileOpen(true)}
                    >
                        <Menu size={24} />
                    </button>
                    <div className="flex justify-end items-center gap-3">
                        <LayoutDashboard size={24} />
                        <History size={24} />
                        <div className="size-6 rounded-full">
                            <img src={usermain} alt="avatar" className="w-full h-full object-cover rounded-full" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const UserDropdown = ({ collapsed, navigate, dropdownRef, user, handlelogout }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [tooltip, setTooltip] = useState(null);
    const buttonRef = useRef(null);

    const showTooltip = (e, text) => {
        if (!collapsed) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            text,
            top: rect.top + rect.height / 2,
            left: rect.right + 8,
        });
    };

    const hideTooltip = () => setTooltip(null);

    const menuItems = [
        { icon: Settings, text: "Settings", onClick: () => navigate("/setting") },
        { icon: HelpCircle, text: "Help & Support", onClick: () => navigate("/help-support") },
        { icon: LogOut, text: "Sign out", onClick: handlelogout },
    ];

    return (
        <div ref={dropdownRef} className="relative">
            {/* User Avatar Button */}
            <button
                type="button"
                ref={buttonRef}
                onClick={() => setDropdownOpen((o) => !o)}
                onMouseEnter={(e) => showTooltip(e, user?.full_name || "User")}
                onMouseLeave={hideTooltip}
                className={`
          flex w-full items-center gap-x-2 p-1 text-start text-sm
          text-gray-800 rounded-md hover:bg-gray-100 transition-all
          ${collapsed ? "justify-center" : ""}
        `}
            >
                <img
                    className="size-8 object-cover rounded-full flex-shrink-0"
                    src={usermain}
                    alt="Avatar"
                />
                {!collapsed && (
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium truncate">
                            {user?.full_name || "User"}
                        </p>
                        <p className="text-xs text-gray-500 truncate">
                            {user?.email || ""}
                        </p>
                    </div>
                )}
                <ChevronsUpDown
                    className={`shrink-0 size-3.5 transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}
                />
            </button>

            {/* Dropdown Menu */}
            <div
                className={`
          absolute bottom-full left-1 mb-2  bg-white border border-gray-200
          rounded-lg shadow-lg transition-all duration-200 z-50
          ${dropdownOpen ? "opacity-100 visible translate-y-0" : "opacity-0 invisible translate-y-1"}
          ${collapsed ? "w-12" : "w-56"}
        `}
            >
                <div className="p-1">
                    {menuItems.map((item, idx) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={idx}
                                onClick={() => {
                                    item.onClick();
                                    setDropdownOpen(false);
                                }}
                                onMouseEnter={(e) => showTooltip(e, item.text)}
                                onMouseLeave={hideTooltip}
                                className="flex w-full items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100"
                            >
                                <Icon className="size-4 flex-shrink-0" />
                                {!collapsed && (
                                    <span>{item.text}</span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* Tooltip for collapsed mode */}
            {tooltip && collapsed && (
                <div
                    className="fixed z-50 bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap pointer-events-none shadow-lg"
                    style={{
                        left: tooltip.left,
                        top: tooltip.top,
                        transform: "translateY(-50%)",
                    }}
                >
                    {tooltip.text}
                </div>
            )}
        </div>
    );
};

export default Sidebar;